import { AddToCart, QuantitySelector } from "../../snippets"
import { ProductOptions } from './ProductOptions';

export function ProductSelection({
  enabledQuantitySelector,
  product,
  selectedOptions,
  selectedVariant,
  setSelectedOptions,
  isGiftCard,
  inventory,
  inventoryFetched,
  quantity,
  handleDecrement,
  handleIncrement,
  isSticky,
  refElement,
  lowInventoryNotification,
  enabledsizeGuide,
  sizeGuides,
  swatches,
  disableGroupHistory,
  enabledSoldOutColorSwatch,
  isSoldOut,
  soldOutQty,
  enabledGroupTabs,
  enabledGroupTabsLink,
  productTypeForGroupTabs,
  enabledGroupOptions,
  enabledGroupOptionsLink,
  productTypeForGroupOptions,
  needsSelection,
  optionChanges,
  setOptionChanges,
  groupedBreadcrumbs,
}) {
  const hideOptions =
    product.variants?.length === 1 &&
    product.variants?.[0].title === 'Default Title';

  const lowInventoryQty = soldOutQty + lowInventoryNotification?.qty;
  const lowInventoryMinQty = soldOutQty + 3;
  const selectedVariantId = selectedVariant?.id;
  const quantityAvailable = inventory?.variants?.[selectedVariantId]?.quantityAvailable ?? null;
  const selectedInventoryQty = quantityAvailable - soldOutQty;
  const isLowInventory = inventory?.totalInventory <= lowInventoryQty;
  const isLowInventoryQty = quantityAvailable <= lowInventoryQty;
  const isLowInventoryMin = quantityAvailable <= lowInventoryMinQty;
  const lowInventoryMessage = isLowInventory
    ? (needsSelection 
        ? lowInventoryNotification?.message 
        : (isLowInventoryMin ? `Only ${selectedInventoryQty} left in stock` : lowInventoryNotification?.message))
    : (isLowInventoryQty
        ? (isLowInventoryMin ? `Only ${selectedInventoryQty} left in stock` : lowInventoryNotification?.message) 
        : null);
  const enabledLowInventory =
    lowInventoryNotification?.enabled &&
    !isGiftCard &&
    inventoryFetched &&
    !isSoldOut &&
    quantityAvailable > soldOutQty
      ? isLowInventory ||
        (isLowInventoryQty &&
          !needsSelection)
      : false;
  
  return (
    <div className="flex flex-col gap-5">
      {!isSticky && (
        <div className="flex flex-col gap-2.5">
          {!hideOptions && (
            <ProductOptions
              product={product}
              selectedOptions={selectedOptions}
              inventory={inventory}
              inventoryFetched={inventoryFetched}
              setSelectedOptions={setSelectedOptions}
              enabledsizeGuide={enabledsizeGuide}
              sizeGuides={sizeGuides}
              swatches={swatches}
              disableGroupHistory={disableGroupHistory}
              enabledSoldOutColorSwatch={enabledSoldOutColorSwatch}
              isSoldOut={isSoldOut}
              soldOutQty={soldOutQty}
              enabledGroupTabs={enabledGroupTabs}
              enabledGroupTabsLink={enabledGroupTabsLink}
              productTypeForGroupTabs={productTypeForGroupTabs}
              enabledGroupOptions={enabledGroupOptions}
              enabledGroupOptionsLink={enabledGroupOptionsLink}
              productTypeForGroupOptions={productTypeForGroupOptions}
              needsSelection={needsSelection}
              optionChanges={optionChanges}
              setOptionChanges={setOptionChanges}
              groupedBreadcrumbs={groupedBreadcrumbs}
            />
          )}

          {enabledQuantitySelector && (
            <div className="flex flex-col gap-2.5">
              <h3 className="text-label text-darkGray">Quantity</h3>
              <QuantitySelector
                disableDecrement={quantity === 1}
                handleDecrement={handleDecrement}
                handleIncrement={handleIncrement}
                productTitle={product.title}
                quantity={quantity}
              />
            </div>
          )}

          {enabledLowInventory && (
            <p className="text-sm text-secondary mt-2.5 mb-0">
              {lowInventoryMessage}
            </p>
          )} 
        </div>
      )}

      <div ref={refElement} className="flex-1">
        <AddToCart
          isPdp
          quantity={quantity}
          selectedVariant={selectedVariant}
          optionChanges={optionChanges}
          needsSelection={needsSelection}
          forceSoldOut={isSoldOut}
        />
      </div>
    </div>
  )
}

ProductSelection.displayName = 'ProductSelection'